import React, { useEffect, useRef, useState } from 'react';
import colors from 'shared-components/theme/colors';
import { gilroyMedium } from 'shared-components/theme/fonts';
import { baseURL } from 'shared-components/theme/helpers';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
const GoesBreadcrubms = () => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            window.addEventListener('click', handleClickOutside);
        }

        return () => {
            window.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen]);
    return (
        <Wrapper isOpen={isOpen}>
            <li>
                <a href="#">ibex Geos</a>
            </li>
            <li>
                <a href="#">Pakistan</a>
            </li>
            {/* <li className="has_dropdown" onClick={toggleOpen}>
                <a href="#">
                    More Geos <span>+</span>
                </a>

                <div
                    className={`dropDown_wrapp ${isOpen ? 'active' : ''}`}
                    ref={containerRef}>
                    <ul>
                        <li>
                            <a href="#">
                                <img
                                    src={`${baseURL}assets/images/geos/pakistan/phillipines.svg`}
                                    alt="ibex-geos"
                                    width={22}
                                    height={11}
                                />
                                Philippines
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img
                                    src={`${baseURL}assets/images/geos/pakistan/jamaica.svg`}
                                    alt="ibex-geos"
                                    width={22}
                                    height={11}
                                />
                                Jamaica
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img
                                    src={`${baseURL}assets/images/geos/pakistan/nicaragua.svg`}
                                    alt="ibex-geos"
                                />
                                Nicaragua
                            </a>
                        </li>
                    </ul>
                </div>
            </li> */}
        </Wrapper>
    );
};

export default GoesBreadcrubms;

const Wrapper = styled.ul`
    max-width: max-content;
    display: flex;
    align-items: center;
    gap: 50px;
    padding: 0;
    margin: 0;

    ${Media('mobile')} {
        gap: 20px;
    }

    li {
        position: relative;

        &::after {
            content: '';
            position: absolute;
            right: -30px;
            top: 50%;
            transform: translateY(-50%);
            width: 9px;
            height: 15px;
            background: url(${`${baseURL}assets/images/geos/pakistan/caret-right.svg`})
                no-repeat center/cover;

            ${Media('mobile')} {
                right: -13px;
                width: 5px;
                height: 10px;
            }
        }

        &:last-child {
            &::after {
                background: unset;
            }
        }
        &:first-child:not(.dropDown_wrapp li) {
            a {
                color: ${colors.geoWhite[50]};
            }
        }
        &.has_dropdown {
            transition: 0.3s ease;
            background: ${(props) =>
                props.isOpen ? colors.geoGreen[100] : 'transparent'};
            padding: 10px 46px 10px 18px;
            border-radius: 10px 10px 0 0;
        }
        .dropDown_wrapp {
            position: absolute;
            left: 0;
            width: 100%;
            height: 0;
            z-index: 1;
            transition: 0.3s ease;
            overflow: hidden;
            &.active {
                height: 229px;
            }
            ul {
                background: ${colors.geoGreen[100]};
                border-radius: 0 0 10px 10px;
                padding: 20px 0 0;
                li {
                    border-bottom: 1px solid #042914;
                    padding: 4px 18px;
                    &::after {
                        background: unset;
                    }

                    a {
                        color: ${colors.geoWhite[70]};
                        padding: 10px 0;

                        &:hover {
                            color: ${colors.white[100]};
                        }
                    }
                }
            }
        }
        a {
            font-family: ${gilroyMedium};
            color: ${colors.geoWhite[100]};
            font-size: 16px;
            font-weight: 500;
            transition: 0.3s ease;
            display: flex;
            align-items: center;
            gap: 20px;
            ${Media('large')} {
                font-size: 0.952vw;
            }
            ${Media('mobile')} {
                font-size: 12px;
            }

            &:hover {
                color: ${colors.white[100]};
            }

            span {
                border: ${(props) =>
                    props.isOpen
                        ? `2px solid #3BF78A`
                        : `2px solid ${colors.geoWhite[100]}`};
                color: ${(props) =>
                    props.isOpen ? `#3BF78A` : `${colors.geoWhite[100]}`};
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 17px;
                width: 17px;
                padding-top: 2px;
                transition: 0.3s ease;
                ${Media('mobile')} {
                    padding-top: 1px;
                }
            }
        }
    }
`;
